import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { loc, catLabel } from "@/lib/localize";

function fmtDate(d, isAr) {
  try {
    return new Date(d).toLocaleDateString(isAr ? "ar" : "en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

const FALLBACK = "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export function ArticleCard({ article }) {
  const { isAr, L } = useLang();
  return (
    <Link
      to={`/market-analysis/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-hair bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
      data-testid={`article-card-${article.slug}`}
    >
      <div className="relative h-44 overflow-hidden bg-canvas">
        <img
          src={article.featured_image || FALLBACK}
          alt={loc(article, "title", isAr)}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute start-3 top-3 rounded-md bg-navy/90 px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold backdrop-blur">
          {catLabel(article.category, isAr)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-heading text-lg font-semibold leading-snug text-ink transition-colors group-hover:text-finblue">
          {loc(article, "title", isAr)}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-subtle line-clamp-2">{loc(article, "excerpt", isAr)}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-subtle">
          <span>{fmtDate(article.published_at, isAr)}</span>
          <span className="flex items-center gap-1">
            <Clock className="h-3.5 w-3.5" /> {article.reading_time} {L.common.min}
          </span>
        </div>
      </div>
    </Link>
  );
}
